import React, { useEffect, useState } from 'react'
import { Descriptions, Input, InputNumber, DatePicker, Form, Tooltip, Select, FloatButton, Spin, AutoComplete, } from "antd";
import { DownloadOutlined, EditOutlined, ExportOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { agreementOptions, natureOptions } from '../../utils/Constant';
import ButtonComp from '../button/ButtonComp';
import axiosInstance from '../../utils/axiosInstance';
import { capitalizeAndRemoveUnderscores } from '../../utils/utils';


const BussinessDetailsComponent = ({ contract, editedContract, editMode, handleEdit, handleCancel, handleSave, newData, setEditedContract, handleAddressChange, fetchState, clientStates, partyStates, handleAgreementChange, years, setYears, months, setMonths, days, setDays, setExecutionDate, setDateModalVisible, setEffectiveDate, setIsLinkedModalVisible, handleOpenLinkedModal, fetchAgreementPdf, isLoading, }) => {
    const select = useSelector((state) => state.auth.userInfo);
    const navigate = useNavigate();
    const [countries, setCountries] = useState();
    const dropdownStyle = {
        width: "auto",
        minWidth: "150px",
        maxWidth: "300px",
    };
    const role = select.role;
    const user_email = select.user_email;
    const user_id = select.user_id;
    const dateFormat = "DD-MM-YYYY";

    useEffect(() => {
        const fetchCountry = async () => {
            try {
                const response = await axiosInstance.get(`/country/get/`)
                setCountries(response.data);
            } catch (error) {
                console.error(error)
            }
        };
        fetchCountry();
    }, []);
    return (
        <div>
            <div className="text-black mt-2 pb-5 px-2 h-[55px] flex flex-col md:flex-row md:items-center md:justify-between">
                <span className="flex flex-row justify-center text-center items-center">
                    <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white">
                        Business Partner
                    </h1>
                    {role &&
                        contract &&
                        ((contract.editable_user &&
                            contract.status !== "EXECUTED" &&
                            contract.status !== "TRANSACTION_CLOSED" &&
                            parseInt(user_id) ===
                            parseInt(contract.editable_user) &&
                            ((role?.toLocaleLowerCase() === "agreement controller head") || (role?.toLocaleLowerCase() === "professional agreement controller team") || (role?.toLocaleLowerCase() === "professional agreement controller head") || (role === "professional") ||
                                (role?.toLocaleLowerCase() === "agreement controller team"))) ||
                            (contract.is_draft &&
                                contract.created_by ===
                                user_email)) ? (
                        <>
                            {!editMode && editedContract && (
                                <div className="edit-icon">
                                    <EditOutlined
                                        onClick={handleEdit}
                                        className="h-4 ml-2 text-lg transform scale-125 dark:text-white hover:scale-150 transition-transform duration-300 cursor-pointer"
                                    />
                                </div>
                            )}
                        </>
                    ) : null}
                </span>
                {editMode && editedContract ? (
                    <div className="flex justify-between">
                        <div className="flex">
                            <ButtonComp
                                width="7em"
                                text={"Cancel"}
                                onClick={handleCancel}
                                margin={"4px"}
                                textColor="#4E36A3"
                            ></ButtonComp>
                            <ButtonComp
                                width="7em"
                                type="primary"
                                onClick={() => handleSave(newData)}
                                className=""
                                text={"Save"}
                                textColor="white"
                                bgColor="#4E36A3"
                            ></ButtonComp>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>

            <Descriptions
                title=""
                layout="vertical"
                bordered
                size="small"
                className="responsive-descriptions mt-[-10px] agreement-detail text-[12px] [&_.ant-descriptions-item-label]:text-[11px] [&_.ant-descriptions-item-content]:text-[12px] [&_.ant-descriptions-item]:p-[6px]"
            >
                <Descriptions.Item
                    label="Name"
                    span={1}
                >
                    {editMode && editedContract ? (
                        <Input
                            name="name_of_client"
                            value={
                                editedContract.name_of_client
                            }

                            onChange={(e) => { setEditedContract({ ...editedContract, name_of_client: e.target.value }) }}
                        />
                    ) : (
                        <Descriptions.Item label="Name">
                            {contract.name_of_client}
                        </Descriptions.Item>
                    )}
                </Descriptions.Item>
                <Descriptions.Item
                    label="Authorized Signatory’s Name of Business Partner"
                    span={2}
                >
                    {editMode && editedContract ? (
                        <Input
                            name="name_of_authorised_signatory_of_party"
                            value={
                                editedContract.name_of_authorised_signatory_of_party
                            }

                            onChange={(e) => { setEditedContract({ ...editedContract, name_of_authorised_signatory_of_party: e.target.value }) }}
                        />
                    ) : (
                        contract.name_of_authorised_signatory_of_party || "-"
                    )}
                </Descriptions.Item>

                <Descriptions.Item label="Address Line 1" span={1}>
                    {editMode && editedContract ? (
                        <Input
                            name="address1"
                            defaultValue={
                                editedContract &&
                                editedContract.client_address &&
                                editedContract.client_address.address1
                            }
                            // onChange={handleAdress1Change}
                            onChange={(e) =>
                                handleAddressChange(e, "client_address")
                            }
                            required
                        />
                    ) : (contract?.client_address?.address1 || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Address Line 2" span={1}>
                    {editMode && editedContract ? (
                        <Input
                            name="address2"
                            defaultValue={
                                editedContract &&
                                editedContract.client_address &&
                                editedContract.client_address.address2
                            }
                            // onChange={handleAddress2Change}
                            onChange={(e) =>
                                handleAddressChange(e, "client_address")
                            }
                        />
                    ) : (
                        contract.client_address &&
                        contract.client_address.address2 || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="City">
                    {editMode && editedContract ? (
                        <Input
                            name="city"
                            defaultValue={
                                editedContract &&
                                editedContract.client_address &&
                                editedContract.client_address.city
                            }
                            // onChange={handleCityChange}
                            onChange={(e) =>
                                handleAddressChange(e, "client_address")
                            }
                        />
                    ) : (
                        contract &&
                        contract.client_address &&
                        contract.client_address.city || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="PIN">
                    {editMode && editedContract ? (
                        <Input
                            name="postal_code"
                            defaultValue={
                                editedContract &&
                                editedContract.client_address &&
                                editedContract.client_address.postal_code
                            }
                            // onChange={handleAddressChange}
                            onChange={(e) =>
                                handleAddressChange(e, "client_address")
                            }
                        />
                    ) : (
                        contract &&
                        contract.client_address &&
                        contract.client_address.postal_code || "-"
                    )}
                </Descriptions.Item>

                <Descriptions.Item label="Country">
                    {editMode && editedContract ? (
                        <Select
                            defaultValue={editedContract?.client_address?.country?.id}
                            // onChange={handleClientCountryChange}
                            onChange={(value) => {
                                fetchState(value, "client");
                                setEditedContract({ ...editedContract, client_address: { ...editedContract.client_address, country: { id: value }, state: null } })
                            }
                            }
                            style={{ width: "100%" }} // Set the width of the Select component
                            dropdownStyle={dropdownStyle} //
                            autoWidth
                        >
                            {countries &&
                                countries.map((country) => (
                                    <Select.Option key={country.id} value={country.id}>
                                        {country.name}
                                    </Select.Option>
                                ))}
                        </Select>
                    ) : (

                        contract?.client_address?.country?.name || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="State">
                    {editMode && editedContract ? (
                        <Select
                            defaultValue={contract?.client_address?.state?.id}
                            value={editedContract?.client_address?.state?.id}
                            onChange={(value) =>
                                handleAddressChange(
                                    { target: { name: "state", value } },
                                    "client_address",
                                    "select",
                                    "state"
                                )
                            }
                            autoWidth
                            style={{ width: "100%" }} // Set the width of the Select component
                        >
                            {clientStates.length > 0 &&
                                clientStates.map((state) => (
                                    <Select.Option key={state.id} value={state.id}>
                                        {state.name}
                                    </Select.Option>
                                ))}
                        </Select>
                    ) : (
                        contract &&
                        contract.client_address &&
                        contract.client_address.state &&
                        contract.client_address.state.name || "-"
                    )}
                </Descriptions.Item>
            </Descriptions>
            <h1 className="font-semibold text-[15px] pt-[1%]">
                Business Entity
            </h1>
            <Descriptions
                title=""
                layout="vertical"
                bordered
                size="small"
                className="mt-4 responsive-descriptions agreement-detail text-[12px] [&_.ant-descriptions-item-label]:text-[11px] [&_.ant-descriptions-item-content]:text-[12px] [&_.ant-descriptions-item]:p-[6px]"
            >
                <Descriptions.Item
                    label="Name"
                    span={2}
                >
                    {editMode && editedContract ? (
                        <Input
                            name="party"
                            value={
                                editedContract.party
                            }
                            onChange={(e) => { setEditedContract({ ...editedContract, party: e.target.value }) }}
                        />
                    ) : (
                        contract.party || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item
                    label="Authorized Signatory’s Name of Business Entity"
                    span={2}
                >
                    {editMode && editedContract ? (
                        <Input
                            name="name_of_authorised_signatory_of_client"
                            value={
                                editedContract.name_of_authorised_signatory_of_client
                            }
                            onChange={(e) => { setEditedContract({ ...editedContract, name_of_authorised_signatory_of_client: e.target.value }) }}
                        />
                    ) : (
                        contract.name_of_authorised_signatory_of_client || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Address Line 1" span={1}>
                    {editMode && editedContract ? (
                        <Input
                            name="address1"
                            defaultValue={
                                editedContract &&
                                editedContract.party_address &&
                                editedContract.party_address.address1
                            }
                            // onChange={handleAdressChange}
                            // onChange={handlePinChange}
                            onChange={(e) =>
                                handleAddressChange(e, "party_address")
                            }
                        />
                    ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.address1 || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Address Line 2" span={1}>
                    {editMode && editedContract ? (
                        <Input
                            name="address2"
                            defaultValue={
                                editedContract &&
                                editedContract.party_address &&
                                editedContract.party_address.address2
                            }
                            // onChange={handleAddress2Change}
                            onChange={(e) =>
                                handleAddressChange(e, "party_address")
                            }
                        />
                    ) : (
                        contract.party_address && contract.party_address.address2 || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="City" span={1}>
                    {editMode && editedContract ? (
                        <Input
                            name="city"
                            defaultValue={
                                editedContract &&
                                editedContract.party_address &&
                                editedContract.party_address.city
                            }
                            // onChange={handlPartyCityChange}
                            onChange={(e) =>
                                handleAddressChange(e, "party_address")
                            }
                        />
                    ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.city || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="PIN" span={1}>
                    {editMode && editedContract ? (
                        <Input
                            name="postal_code"
                            defaultValue={
                                editedContract &&
                                editedContract.party_address &&
                                editedContract.party_address.postal_code
                            }
                            // onChange={handleAddressChange}
                            onChange={(e) =>
                                handleAddressChange(e, "party_address")
                            }
                        />
                    ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.postal_code || "-"
                    )}
                </Descriptions.Item>

                <Descriptions.Item label="Country" span={1}>
                    {editMode && editedContract ? (
                        <Select

                            defaultValue={
                                contract &&
                                contract.party_address &&
                                contract.party_address.country &&
                                contract.party_address.country.id
                            }
                            onChange={(value) => {
                                fetchState(value, "party");
                                setEditedContract({ ...editedContract, party_address: { ...editedContract.party_address, country: { id: value }, state: null } })
                            }
                            }
                            autoWidth
                            style={{ width: "100%" }}
                        >
                            {countries &&
                                countries.map((country) => (
                                    <Select.Option key={country.id} value={country.id}>
                                        {country.name}
                                    </Select.Option>
                                ))}
                        </Select>
                    ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.country &&
                        contract.party_address.country.name || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="State" span={1}>
                    {editMode && editedContract ? (
                        <Select
                            name='state'
                            defaultValue={
                                contract &&
                                contract.party_address &&
                                contract.party_address.state &&
                                contract.party_address.state.id
                            }
                            // onChange={handlePartyStateChange}
                            onChange={(value) =>
                                handleAddressChange(
                                    { target: { name: "state", value } },
                                    "party_address",
                                    "select",
                                    "state"
                                )
                            }
                            autoWidth
                            style={{ width: "100%" }}
                        >
                            {partyStates && partyStates.length > 0 &&
                                partyStates.map((state) => (
                                    <Select.Option key={state.id} value={state.id}>
                                        {state.name}
                                    </Select.Option>
                                ))}
                        </Select>
                    ) : (
                        contract &&
                        contract.party_address &&
                        contract.party_address.state &&
                        contract.party_address.state.name || "-"
                    )}
                </Descriptions.Item>
            </Descriptions>
            <h1 className="font-semibold text-[15px] pt-[1%]">
                Agreement Details
            </h1>
            <Descriptions
                title=""
                layout="vertical"
                bordered
                size="small"
                className="mt-4  text-[12px] [&_.ant-descriptions-item-label]:text-[11px] [&_.ant-descriptions-item-content]:text-[12px] [&_.ant-descriptions-item]:p-[6px]"
            >
                <Descriptions.Item label="Agreement Type">
                    {editMode && editedContract ? (<>
                        <Form.Item
                            name="agreement_type"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Ageement Type",
                                },
                            ]}
                        >
                            <AutoComplete
                                options={agreementOptions.map((option) => ({
                                    value: option.value,
                                }))}
                                filterOption={(inputValue, option) =>
                                    option.value
                                        .toUpperCase()
                                        .indexOf(inputValue.toUpperCase()) !== -1
                                }
                                placeholder="Select or type to add agreement"
                                onChange={(val) => handleAgreementChange(val, 'agreement_type')}
                                defaultValue={contract?.agreement_type}
                            />
                        </Form.Item>
                    </>
                    ) : (
                        contract && contract.agreement_type || "-"
                    )}
                </Descriptions.Item>

                <Descriptions.Item label="Nature">
                    {editMode && editedContract ? (
                        <Form.Item
                            // label="Agreement"
                            name="agreement_type"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Ageement Type",
                                },
                            ]}
                        >
                            <AutoComplete
                                options={natureOptions.map((option) => ({
                                    value: option.value,
                                }))}
                                filterOption={(inputValue, option) =>
                                    option.value
                                        .toUpperCase()
                                        .indexOf(inputValue.toUpperCase()) !== -1
                                }
                                onChange={(val) => handleAgreementChange(val, 'nature')}
                                placeholder="Select or type to add nature"
                                defaultValue={contract && contract.nature}
                            />
                        </Form.Item>
                    ) : (
                        contract && contract.nature || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Tenure">
                    {editMode && editedContract ? (
                        <div className='w-full flex justify-start items-center gap-[10px] mt-[-20px]'>
                            <InputNumber
                                min={0}
                                value={years}
                                onChange={(e) => { setYears(e) }}
                                placeholder="Years"
                            />
                            <InputNumber
                                min={0}
                                value={months}
                                onChange={(e) => { setMonths(e) }}
                                placeholder="Months"
                            />
                            <InputNumber
                                min={0}
                                value={days}
                                onChange={(e) => { setDays(e) }}
                                placeholder="Days"
                            />
                        </div>

                    ) : (
                        contract.tenure || "-"
                    )}
                </Descriptions.Item>

                <Descriptions.Item label="Termination Notice">
                    {editMode && editedContract ? (
                        <Input
                            name="termination_notice"
                            value={editedContract.termination_notice}
                            onChange={(e) => handleAgreementChange(e.target.value, 'termination_notice')}
                        />
                    ) : (
                        contract.termination_notice || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Jurisdiction">
                    {editMode && editedContract ? (
                        <Input
                            name="jurisdiction"
                            value={editedContract.jurisdiction}
                            onChange={(e) => handleAgreementChange(e.target.value, 'jurisdiction')}


                        />
                    ) : (
                        contract.jurisdiction || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Execution Date" span={1}>
                    {editMode && editedContract ? (
                        <DatePicker
                            name="date_of_execution"
                            style={{ width: "100%" }}
                            format="DD-MM-YYYY"
                            defaultValue={
                                contract.date_of_execution
                                    ? dayjs(
                                        dayjs(
                                            contract.date_of_execution,
                                            "YYYY-MM-DD"
                                        ).format("DD-MM-YYYY"),
                                        dateFormat
                                    )
                                    : null
                            }
                            onChange={(date) => {
                                if (!date) return;

                                const selectedDate = dayjs(date);
                                const today = dayjs().startOf("day");

                                setExecutionDate(selectedDate.format("YYYY-MM-DDTHH:mm:ss"));

                                if (selectedDate.isAfter(today, 'day')) {
                                    setDateModalVisible(true);
                                }
                            }}
                            disabledDate={() => false}
                        />
                    ) : (
                        contract.date_of_execution &&
                        dayjs(contract.date_of_execution).format("DD-MM-YYYY") || "-"
                    )}
                </Descriptions.Item>

                <Descriptions.Item label="Effective Date" span={1}>
                    {editMode && editedContract ? (
                        <DatePicker
                            name="effective_date"
                            style={{ width: "100%" }}
                            format="DD-MM-YYYY"
                            disabledDate={() => false}
                            defaultValue={
                                contract.effective_date
                                    ? dayjs(
                                        dayjs(
                                            contract.effective_date,
                                            "YYYY-MM-DD"
                                        ).format("DD-MM-YYYY"),
                                        dateFormat
                                    )
                                    : null
                            }
                            onChange={(date) =>
                                setEffectiveDate(date?.format("YYYY-MM-DDTHH:mm:ss"))
                            }
                        />
                    ) : (
                        contract.effective_date &&
                        dayjs(contract.effective_date).format("DD-MM-YYYY") || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Remarks" span={2}>
                    <div className="flex justify-between">
                        <div>{contract.remarks || "-"} </div>
                    </div>
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                    {capitalizeAndRemoveUnderscores(contract.status) || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Agreeement ID">
                    {contract.document_id && contract.document_id || "-"}
                </Descriptions.Item>
                {contract?.linked_expired_agreements?.length > 0 && (
                    <Descriptions.Item label="Linked Agreement ID">
                        {contract?.linked_expired_agreements?.length === 1 ? (
                            <span
                                className="text-blue-600 cursor-pointer flex justify-between items-center w-2/3"
                                onClick={() =>
                                    navigate(`/admin/contracts/${contract?.linked_expired_agreements[0]?.linked_agreement_id}`)
                                }
                            >
                                <div>
                                    {contract?.linked_expired_agreements[0]?.linked_document_id}
                                </div>
                                <ExportOutlined
                                    className="text-blue-600 cursor-pointer"
                                    onClick={() => {
                                        setIsLinkedModalVisible(false);
                                        navigate(`/admin/contracts/${contract?.linked_expired_agreements[0]?.linked_agreement_id}`);
                                    }}
                                />
                            </span>
                        ) : (
                            <span
                                className="text-blue-400 cursor-pointer underline-offset-1"
                                onClick={handleOpenLinkedModal}
                            >
                                View Linked Agreements ({contract?.linked_expired_agreements.length})
                            </span>
                        )}
                    </Descriptions.Item>
                )}


            </Descriptions>
            {contract && (
                <Tooltip title={"Download Ageement Details"}>
                    <FloatButton
                        onClick={() => fetchAgreementPdf(contract.id)}
                        icon={isLoading ? <Spin /> : <DownloadOutlined />}
                        description=""
                        shape="square"
                        style={{
                            right: 120,
                            bottom: -10,
                            width: "6em",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    />
                </Tooltip>
            )}
        </div>
    )
}

export default BussinessDetailsComponent